import { DateTime } from 'luxon';
import { storage, StorageKey } from '@/services/storage';
import { Timezone } from '@/entities';

export const getLocalTimezone = (): Timezone => {
  const localTimezone = DateTime.local().zoneName;
  const storedTimezone = storage.getItem(StorageKey.TIMEZONE);

  if (storedTimezone) {
    return storedTimezone as Timezone;
  }

  if (localTimezone === 'Europe/Kiev') {
    return 'Europe/Kyiv';
  }

  return localTimezone as Timezone;
};
